import styled from 'styled-components'

export const StyledSignaturePreviewContainer = styled.div`
  align-self: center;
  justify-self: center;
  display: flex;
  flex-direction: column;

  & img {
    height: 50px;
    width: 200px;
    object-fit: contain;
  }
`
